export interface AppVersionInfo {
  version: string;
  buildAt?: string;
}

export interface ChangelogItem {
  type?: string;
  title: string;
  body?: string;
}

export interface ChangelogResponse {
  version?: string;
  date?: string;
  items?: ChangelogItem[];
}

const cacheBustParam = () => `ts=${Date.now()}`;

export async function fetchAppVersion(): Promise<AppVersionInfo | null> {
  try {
    const res = await fetch(`/version.json?${cacheBustParam()}`, {
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) return null;
    const data = (await res.json()) as AppVersionInfo;
    if (!data || typeof data.version !== 'string') return null;
    return data;
  } catch (e) {
    console.error('fetchAppVersion error', e);
    return null;
  }
}

export async function fetchChangelog(): Promise<ChangelogResponse | null> {
  try {
    const res = await fetch(`/changelog.json?${cacheBustParam()}`, {
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) return null;
    const data = (await res.json()) as ChangelogResponse;
    return data || null;
  } catch (e) {
    console.error('fetchChangelog error', e);
    return null;
  }
}


